// extracted by mini-css-extract-plugin
module.exports = {"jds-EmptyState":"emptyState_jds-EmptyState__tMVAq","jds-EmptyState__content":"emptyState_jds-EmptyState__content__yNDh_"};